import { HttpInterceptors } from "./http.interceptor";

export class BudgetService extends HttpInterceptors {
	async getBudgetByParams (filters) {
		const response = await this.axios.get("budget/getBudgetByParams", { params: { filters } });
		return response.data;
	}

	async createBudget (payload) {
		const response = await this.axios.post("budget/createBudget", payload);
		return response.data;
	}

	async updateBudget (payload) {
		const response = await this.axios.patch("budget/updateBudget", payload);
		return response.data;
	}

	async deleteBudget (payload) {
		const response = await this.axios.patch("budget/deleteBudget", payload);
		return response.data;
	}
}
